"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterTestValues = filterTestValues;
exports.getReferenceDate = void 0;
exports.mergeMerchants = mergeMerchants;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _filters = require("../constants/filters");

var _lodash = _interopRequireDefault(require("lodash"));

/**
 * @description helper to merge similar merchants as one
 * @param {Array} merchants list of merchants
 * @returns {Array} list of merchants with merged businesses
 */
function mergeMerchants() {
  var merchants = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var mergedMerchant = [];

  _filters.MERGE_BUSINESS.forEach(function (business) {
    mergedMerchant.push({
      displayName: business.displayName,
      merchantId: merchants.filter(function (merchant) {
        return _lodash["default"].lowerCase(merchant.merchantId).startsWith(business.prefix);
      }).map(function (_ref) {
        var merchantId = _ref.merchantId;
        return merchantId;
      })
    });

    _lodash["default"].remove(merchants, function (merchant) {
      return _lodash["default"].lowerCase(merchant.merchantId).startsWith(business.prefix);
    });
  });

  return _lodash["default"].sortBy([].concat(mergedMerchant, (0, _toConsumableArray2["default"])(merchants)), 'displayName');
}
/**
 * @description filter out data with passed regex for particular field
 * @param {Array} data list to be filtered
 * @param {String} fieldName comparison/predicate field for filter
 * @param {String} regex string equivalent of regex
 * @returns {Array} filtered list of data
 */


function filterTestValues(_ref2) {
  var _ref2$data = _ref2.data,
      data = _ref2$data === void 0 ? [] : _ref2$data,
      fieldName = _ref2.fieldName,
      regex = _ref2.regex;
  regex = new RegExp(regex, 'i');
  return data.filter(function (item) {
    var _item$fieldName;

    return ((_item$fieldName = item[fieldName]) === null || _item$fieldName === void 0 ? void 0 : _item$fieldName.trim().length) > 0 && !regex.test(item[fieldName]);
  });
}
/**
 * @description function to provide yesterday's date string
 * @returns date string for yesterday
 */


var getReferenceDate = function getReferenceDate() {
  var referenceDate = new Date();
  referenceDate.setDate(referenceDate.getDate() - 1);
  var year = referenceDate.getFullYear();
  var month = referenceDate.getMonth() + 1;
  var day = referenceDate.getDate();
  return "".concat(year, "/").concat(month < 10 ? "0".concat(month) : month, "/").concat(day < 10 ? "0".concat(day) : day);
};

exports.getReferenceDate = getReferenceDate;